import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  redButton: {
    backgroundColor: theme.palette.error.main,
  },
  radioGroup: {
    flexDirection: "row",
  },
  icon: {
    color: "#fff",
    width: "90%",
  },
  acceptedDot: {
    border: theme.palette.success.main,
    borderRadius: "50%",
    width: "25px",
    height: "25px",
    backgroundColor: theme.palette.success.main,
  },
  rejectedDot: {
    border: theme.palette.error.main,
    borderRadius: "50%",
    width: "25px",
    height: "25px",
    backgroundColor: theme.palette.error.main,
  },
}))

export default styles
